import React, { useEffect } from "react";
import { ToastStyle } from "./style";

// fixed toast themes
const TOAST_TYPES = {
  default: { icon: "", colour: "burnt" },
  information: { icon: "info", colour: "burnt" },
  success: { icon: "check", colour: "avocado" },
  warning: { icon: "warning", colour: "honey" },
  error: { icon: "error", colour: "ketchup" },
};

const Toast = (props) => {
  const {
    id,
    title,
    description,
    icon,
    colour,
    actionTitle,
    action,
    dismiss,
    autoDismissOnly,
    type,
  } = props;
  let theme = {
    icon: icon || TOAST_TYPES.default.icon,
    colour: colour || TOAST_TYPES.default.colour,
  };
  if (type) {
    theme = TOAST_TYPES[type];
  }

  useEffect(() => {
    const timeOutId = setTimeout(() => dismiss(id), 2000);
    return () => {
      clearTimeout(timeOutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ToastStyle className={`toast ${theme.colour}`}>
      {theme.icon && <div className={`icon ${theme.icon}`} />}
      {title && <div className="title">{title}</div>}
      {description && <div className="description">{description}</div>}
      {action && (
        <div className="action" onClick={action}>
          {actionTitle || "Action"}
        </div>
      )}
      {!autoDismissOnly && id && (
        <div
          className={`dismiss ${theme.colour}`}
          onClick={() => dismiss(id)}
        />
      )}
    </ToastStyle>
  );
};

export default Toast;
